<!--
~ Copyright (C) 2023 DV Bern AG, Switzerland
~
~ This program is free software: you can redistribute it and/or modify
~ it under the terms of the GNU Affero General Public License as
~ published by the Free Software Foundation, either version 3 of the
~ License, or (at your option) any later version.
~
~ This program is distributed in the hope that it will be useful,
~ but WITHOUT ANY WARRANTY; without even the implied warranty of
~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
~ GNU Affero General Public License for more details.
~
~ You should have received a copy of the GNU Affero General Public License
~ along with this program. If not, see <https://www.gnu.org/licenses/>.
-->
<div class="dv-table">
    <div class="col-md-12">
        <div class="row view-title">
            <div class="col-md-10 col-md-offset-1">
                <h2 class="ng-scope">{{ 'POSTEINGANG' | translate }}</h2>
            </div>
        </div>
        <div class="row margin-top-10">
            <div class="col-md-8 col-md-offset-1">
                <div class="dv-table-actions">
                    <button
                        class="dv-btn posteingang-reset"
                        (click)="resetFilter()"
                    >
                        <i class="fa fa-undo"></i>
                        {{ 'FILTER_ZURUECKSETZEN' | translate }}
                    </button>
                    @if (showAlleMutationenBearbeitenButton()) {
                        <button
                            class="dv-btn posteingang-muta-bearbeiten"
                            (click)="alleMutationsmeldungVerfuegen()"
                            [dvDemoFeature]="mutationsMeldungDemoFeature"
                            data-test="mutationsmeldungen-automatisch-bearbeiten"
                        >
                            <i class="fa fa-flash fa-lg"></i>
                            {{
                                'ALLE_MUTATIONSMELDUNG_AUTOMATISCH_BEARBEITEN'
                                    | translate
                            }}
                        </button>
                    }
                </div>
            </div>
            @if (!isSozialdienstOrInstitution()) {
                <div
                    class="col-md-2 text-right closed-mitteilungen dv-table-resultCombo"
                >
                    <dv-checkbox-x
                        [marginClass]="'no-margin-bottom'"
                        [model]="includeClosed()"
                        (modelChange)="checkbox($event)"
                        [label]="'POSTEINGANG_INCLUDE_CLOSED' | translate"
                        [displayBisher]="false"
                    >
                    </dv-checkbox-x>
                    <h3 class="dv-table-resultcount">{{ totalResultCount }}</h3>
                </div>
            }
        </div>
        <div class="row">
            <div class="col-md-10 col-md-offset-1 ebegu-table table-responsive">
                <mat-table
                    [dataSource]="displayedCollection"
                    matSort
                    (matSortChange)="sortData($event)"
                >
                    <!-- Von -->
                    <ng-container matColumnDef="sender">
                        <mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header="sender"
                        >
                            <span class="no-padding-left" translate
                                >POSTEINGANG_VON</span
                            >
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="ellipsis">
                            <span [title]="element.sender.getFullName()">{{
                                element.sender.getFullName()
                            }}</span>
                        </mat-cell>
                    </ng-container>
                    <!-- Gemeinde -->
                    <ng-container matColumnDef="gemeinde">
                        <mat-header-cell
                            mat-sort-header="gemeinde"
                            *matHeaderCellDef
                            class="ellipsis"
                        >
                            <span translate
                                >POSTEINGANG_GEMEINDE</span
                            ></mat-header-cell
                        >
                        <mat-cell *matCellDef="let element" class="ellipsis">
                            <span [title]="element.dossier.gemeinde.name">{{
                                element.dossier.gemeinde.name
                            }}</span>
                        </mat-cell>
                    </ng-container>
                    <!-- Fall-Nummer -->
                    <ng-container matColumnDef="fallNummer">
                        <mat-header-cell
                            mat-sort-header="fallNummer"
                            *matHeaderCellDef
                            class="ellipsis"
                            data-test="fall-nummer"
                        >
                            <span translate>POSTEINGANG_FALL</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="ellipsis">
                            <span
                                [title]="
                                    addZerosToFallNummer(
                                        element.dossier.fall.fallNummer
                                    )
                                "
                                >{{
                                    addZerosToFallNummer(
                                        element.dossier.fall.fallNummer
                                    )
                                }}</span
                            >
                        </mat-cell>
                    </ng-container>
                    <!-- Familie -->
                    @if (!isSozialdienst()) {
                        <ng-container matColumnDef="familienName">
                            <mat-header-cell
                                mat-sort-header="familienName"
                                *matHeaderCellDef
                                class="ellipsis"
                            >
                                <span translate>POSTEINGANG_FAMILIE</span>
                            </mat-header-cell>
                            <mat-cell
                                *matCellDef="let element"
                                class="ellipsis"
                            >
                                <span
                                    [title]="
                                        element.dossier.fall.besitzer?.getFullName()
                                    "
                                    >{{
                                        element.dossier.fall.besitzer?.getFullName()
                                    }}</span
                                >
                            </mat-cell>
                        </ng-container>
                    }
                    <!-- Betreff -->
                    <ng-container matColumnDef="subject">
                        <mat-header-cell
                            mat-sort-header="subject"
                            *matHeaderCellDef
                            class="ellipsis"
                        >
                            <span translate>POSTEINGANG_BETREFF</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="ellipsis">
                            <span [title]="element.subject">{{
                                element.subject
                            }}</span></mat-cell
                        >
                    </ng-container>
                    <!-- Datum -->
                    <ng-container matColumnDef="sentDatum">
                        <mat-header-cell
                            mat-sort-header="sentDatum"
                            *matHeaderCellDef
                        >
                            <span translate>POSTEINGANG_DATUM</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <span
                                [title]="element.sentDatum.format('DD.MM.YYYY')"
                                >{{
                                    element.sentDatum.format('DD.MM.YYYY')
                                }}</span
                            ></mat-cell
                        >
                    </ng-container>
                    <!-- An -->
                    @if (!isSozialdienstOrInstitution()) {
                        <ng-container matColumnDef="empfaenger">
                            <mat-header-cell
                                mat-sort-header="empfaenger"
                                *matHeaderCellDef
                                translate
                            >
                                <span translate
                                    >POSTEINGANG_AN</span
                                ></mat-header-cell
                            >
                            <mat-cell *matCellDef="let element">
                                <dv-benutzer-entry
                                    [benutzer]="element.empfaenger"
                                    [noIcons]="true"
                                ></dv-benutzer-entry>
                            </mat-cell>
                        </ng-container>
                    }
                    <!-- Amt -->
                    @if (!isSozialdienstOrInstitution()) {
                        <ng-container matColumnDef="empfaengerVerantwortung">
                            <mat-header-cell
                                mat-sort-header="empfaengerVerantwortung"
                                *matHeaderCellDef
                                translate
                            >
                                <span translate>POSTEINGANG_VERANTWORTUNG</span>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                <dv-benutzer-entry
                                    [benutzer]="element.empfaenger"
                                    [noName]="true"
                                ></dv-benutzer-entry>
                            </mat-cell>
                        </ng-container>
                    }
                    <!-- Status -->
                    <ng-container matColumnDef="mitteilungStatus">
                        <mat-header-cell
                            mat-sort-header="mitteilungStatus"
                            *matHeaderCellDef
                        >
                            <span translate>POSTEINGANG_STATUS</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <span
                                [title]="element.mitteilungStatus | translate"
                                >{{
                                    element.mitteilungStatus | translate
                                }}</span
                            >
                            <div class="flex-fill"></div>
                        </mat-cell>
                    </ng-container>
                    <!-- Actions / Buttons -->
                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef>
                            <span translate></span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            @if (isSuperAdmin() && isStatusGelesen(element)) {
                                <button
                                    type="button"
                                    class="dv-btn dv-btn-operation"
                                    (click)="
                                        $event.stopPropagation();
                                        setUngelesen(element)
                                    "
                                >
                                    <i
                                        class="fa fa-envelope fa-lg"
                                        [title]="
                                            'MITTEILUNG_UNGELESEN' | translate
                                        "
                                    ></i>
                                </button>
                            }
                            @if (
                                isSuperAdminOrGemeinde() &&
                                canBeIgnored(element)
                            ) {
                                <button
                                    type="button"
                                    class="dv-btn dv-btn-operation"
                                    (click)="
                                        $event.stopPropagation();
                                        setIgnoriert(element)
                                    "
                                >
                                    <i
                                        class="fa fa-eye-slash fa-lg"
                                        [title]="
                                            'MITTEILUNG_IGNORIEREN' | translate
                                        "
                                    ></i>
                                </button>
                            }
                            @if (
                                isSuperAdminOrGemeinde() &&
                                canMitteilungStatusBeReverted(element)
                            ) {
                                <button
                                    type="button"
                                    class="dv-btn dv-btn-operation"
                                    (click)="
                                        $event.stopPropagation();
                                        setGelesen(element)
                                    "
                                >
                                    <i
                                        class="fa fa-eye fa-lg"
                                        [title]="
                                            'MITTEILUNG_NICHT_IGNORIEREN'
                                                | translate
                                        "
                                    ></i>
                                </button>
                            }
                        </mat-cell>
                    </ng-container>
                    <!-- filter row -->
                    <!-- Von -->
                    <ng-container matColumnDef="sender-filter">
                        <mat-header-cell *matHeaderCellDef="let column">
                            <mat-form-field class="dv-table-mat-form-field">
                                <input
                                    [(ngModel)]="sender"
                                    matInput
                                    name="sender"
                                />
                            </mat-form-field>
                        </mat-header-cell>
                    </ng-container>
                    <!-- Gemeinde -->
                    <ng-container matColumnDef="gemeinde-filter">
                        <mat-header-cell *matHeaderCellDef="let column">
                            <mat-form-field
                                class="dv-table-mat-form-field"
                                floatLabel="never"
                            >
                                <mat-select
                                    [(value)]="gemeinde"
                                    panelClass="mat-select-panel1"
                                    [placeholder]="'ALLE' | translate"
                                >
                                    <mat-option
                                        ><span translate>ALLE</span></mat-option
                                    >
                                    @for (
                                        gemeinde of sortedGemeindenList();
                                        track gemeinde
                                    ) {
                                        <mat-option [value]="gemeinde.name">{{
                                            gemeinde.name
                                        }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </mat-header-cell>
                    </ng-container>
                    <!-- Fall-Nummer -->
                    <ng-container matColumnDef="fallNummer-filter">
                        <mat-header-cell *matHeaderCellDef="let column">
                            <mat-form-field
                                class="dv-table-mat-form-field"
                                data-test="fall-nummer-filter"
                            >
                                <input
                                    [(ngModel)]="fallNummer"
                                    matInput
                                    name="fallNummer"
                                />
                            </mat-form-field>
                        </mat-header-cell>
                    </ng-container>
                    <!-- Familie -->
                    <ng-container matColumnDef="familienName-filter">
                        <mat-header-cell *matHeaderCellDef="let column">
                            <mat-form-field class="dv-table-mat-form-field">
                                <input
                                    [(ngModel)]="familienName"
                                    matInput
                                    name="familienName"
                                />
                            </mat-form-field>
                        </mat-header-cell>
                    </ng-container>
                    <!-- Betreff -->
                    <ng-container matColumnDef="subject-filter">
                        <mat-header-cell *matHeaderCellDef="let column">
                            <mat-form-field class="dv-table-mat-form-field">
                                <input
                                    [(ngModel)]="subject"
                                    matInput
                                    name="subject"
                                />
                            </mat-form-field>
                        </mat-header-cell>
                    </ng-container>
                    <!-- Datum -->
                    <ng-container matColumnDef="sentDatum-filter">
                        <mat-header-cell *matHeaderCellDef="let column">
                            <mat-form-field class="dv-table-mat-form-field">
                                <input
                                    [(ngModel)]="sentDatum"
                                    matInput
                                    name="sentDatum"
                                />
                            </mat-form-field>
                        </mat-header-cell>
                    </ng-container>
                    <!-- An -->
                    @if (!isSozialdienstOrInstitution()) {
                        <ng-container
                            matColumnDef="empfaenger-filter"
                            st-table=""
                        >
                            <mat-header-cell *matHeaderCellDef="let column">
                                <div
                                    dvNewUserSelect
                                    data-test="container.empfaenger-select"
                                    [selectedUser]="initialEmpfaenger"
                                    [showSelectionAll]="true"
                                    [angular2]="true"
                                    [initialAll]="true"
                                    [bgAndTs]="true"
                                    (userChanged)="
                                        filterEmpfaenger($event.user)
                                    "
                                ></div>
                            </mat-header-cell>
                        </ng-container>
                    }
                    <!-- Verantwortung -->
                    @if (!isSozialdienstOrInstitution()) {
                        <ng-container
                            matColumnDef="empfaengerVerantwortung-filter"
                            st-table=""
                        >
                            <mat-header-cell *matHeaderCellDef="let column">
                                <mat-form-field class="dv-table-mat-form-field">
                                    <mat-select
                                        [(value)]="empfaengerVerantwortung"
                                        panelClass="mat-select-panel1"
                                        [placeholder]="'ALLE' | translate"
                                    >
                                        <mat-option
                                            ><span translate
                                                >ALLE</span
                                            ></mat-option
                                        >
                                        @for (
                                            verantwortung of verantwortungList();
                                            track verantwortung
                                        ) {
                                            <mat-option
                                                [value]="verantwortung"
                                                >{{
                                                    verantwortung | translate
                                                }}</mat-option
                                            >
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </mat-header-cell>
                        </ng-container>
                    }
                    <!-- Status -->
                    <ng-container matColumnDef="mitteilungStatus-filter">
                        <mat-header-cell *matHeaderCellDef="let column">
                            <mat-form-field
                                class="dv-table-mat-form-field"
                                floatLabel="never"
                            >
                                <mat-select
                                    [(value)]="mitteilungStatus"
                                    panelClass="mat-select-panel1"
                                    [placeholder]="'ALLE' | translate"
                                >
                                    <mat-option selected
                                        ><span translate>ALLE</span></mat-option
                                    >
                                    @for (
                                        status of getMitteilungsStatus();
                                        track status
                                    ) {
                                        <mat-option [value]="status"
                                            ><span translate>{{
                                                status
                                            }}</span></mat-option
                                        >
                                    }
                                </mat-select>
                            </mat-form-field>
                        </mat-header-cell>
                    </ng-container>
                    <!-- Actions / Buttons -->
                    <ng-container matColumnDef="actions-filter">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    </ng-container>
                    <mat-header-row
                        *matHeaderRowDef="displayedColumns"
                        class="dv-table-mat-header-row"
                    ></mat-header-row>
                    <mat-header-row
                        class="dv-table-mat-header-row"
                        *matHeaderRowDef="filterColumns"
                    ></mat-header-row>
                    <!-- data -->
                    <mat-row
                        *matRowDef="
                            let element;
                            let index = index;
                            columns: displayedColumns
                        "
                        [attr.data-test]="'mitteilung#' + index"
                        (click)="gotoMitteilung(element)"
                        [class]="{
                            'mitteilung-neu':
                                'NEU' === element.mitteilungStatus.toString(),
                            'mitteilung-alt':
                                'NEU' !== element.mitteilungStatus.toString()
                        }"
                    ></mat-row>
                </mat-table>
                <div class="bottom-pagination">
                    <nav>
                        <ul class="pagination">
                            @for (index of paginationItems; track index) {
                                <li [ngClass]="{active: index - 1 === page()}">
                                    <a
                                        (click)="
                                            handlePagination({
                                                pageIndex: index - 1,
                                                pageSize: 20
                                            })
                                        "
                                        >{{ index }}</a
                                    >
                                </li>
                            }
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</div>
